'use strict';

module.exports = [{
    url: '/cities',
    paramsInfo: [{
        name: 'title',
        required: false
    }, {
        name: 'per-page',
        required: false
    }, {
        name: 'page',
        required: false
    }, {
        name: 'lang',
        required: false
    }],
    name: 'cities'
}, {
    url: '/city-page',
    paramsInfo: [{
        name: 'city_id',
        required: true
    }, {
        name: 'page_order',
        required: false
    }, {
        name: 'per-page',
        required: false
    }, {
        name: 'page',
        required: false
    }, {
        name: 'lang',
        required: false
    }],
    name: 'city-page'
}, {
    url: '/types',
    paramsInfo: [{
        name: 'city_id',
        required: true
    }, {
        name: 'show_inactive',
        required: false
    }, {
        name: 'per-page',
        required: false
    }, {
        name: 'page',
        required: false
    }, {
        name: 'lang',
        required: false
    }],
    name: 'types'
}, {
    url: '/warehouses',
    paramsInfo: [{
        name: 'city_ref_id',
        required: true
    }, {
        name: 'delivery_type_id',
        required: true
    }, {
        name: 'isDesktop',
        required: false
    }, {
        name: 'ref',
        required: false
    }, {
        name: 'title',
        required: false
    }, {
        name: 'per-page',
        required: false
    }, {
        name: 'page',
        required: false
    }, {
        name: 'lang',
        required: false
    }, {
        name: 'showAll',
        required: false
    }],
    name: 'warehouses'
}, {
    url: '/streets',
    paramsInfo: [{
        name: 'city_ref_id',
        required: true
    }, {
        name: 'delivery_type_id',
        required: true
    }, {
        name: 'ref',
        required: false
    }, {
        name: 'title',
        required: false
    }, {
        name: 'per-page',
        required: false
    }, {
        name: 'page',
        required: false
    }, {
        name: 'lang',
        required: false
    }, {
        name: 'showAll',
        required: false
    }],
    name: 'streets'
}, {
    url: '/up-post-codes',
    paramsInfo: [{
        name: 'street_id',
        required: true
    }, {
        name: 'house',
        required: true
    }, {
        name: 'post_code',
        required: false
    }, {
        name: 'per-page',
        required: false
    }, {
        name: 'page',
        required: false
    }],
    name: 'post-code'
}, {
    url: '/delivery-data',
    useParser: false,
    formDataUsage: true,
    requestType: 'post',
    paramsInfo: [{
        name: 'data',
        type: 'object',
        required: true
    }],
    name: 'delivery-data'
}];